module.exports = __webpack_public_path__ + "06_mid_yellow.e9b8d75f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/06_mid_yellow.png
// module id = fQPp
// module chunks = 0